import type { ModuleManifest } from '@eis/core/reporting';
import { reportingPermissions as p } from './permissions';
import { reportingResources } from './i18n';

/**
 * The reporting module's single manifest — the Data Suite (SDD-024 §8, A-5).
 *
 * Served on the console host like every module, and ALONE on the data host, whose `config.json`
 * names `modules: ["reporting"]` (decision T-59). `nav` carries the SAME permission declaration
 * the routes are guarded with, so menu and guard cannot drift (Addendum A.2).
 */
export const reportingModule: ModuleManifest = {
  id: 'reporting',
  basePath: '/reporting',
  routes: () => import('./routes'),
  nav: [
    {
      label: 'reporting:nav.reports',
      icon: 'feather:bar-chart-2',
      to: '/reporting/reports',
      section: 'reporting:nav.sections.dataSuite',
      permissions: [[p.reports.view]],
    },
    {
      label: 'reporting:nav.datasets',
      icon: 'feather:database',
      to: '/reporting/datasets',
      section: 'reporting:nav.sections.dataSuite',
      permissions: [[p.datasets.view]],
    },
    {
      label: 'reporting:nav.settings',
      icon: 'feather:settings',
      to: '/reporting/settings',
      section: 'reporting:nav.sections.dataSuite',
      permissions: [[p.settings.manage]],
    },
  ],
  i18nNamespaces: ['reporting'],
  permissionCatalog: p,
  featureFlagPrefix: 'reporting.',
  i18nResources: reportingResources,
};
